import { ClientPrivileges } from "../authentication/ClientPrivilegesEnum";

export enum ReportSubscriptionTypeEnum {
    DevicesContentReport = 0,
    LastDayTransactionsReport = 1,
    DevicesContentCsvReport = 2,
    PlatformMaintenanceReport = 3,
}

export function getSubscriptionTypeLabel(t: string): string {
    switch (parseInt(t) as ReportSubscriptionTypeEnum) {
        case ReportSubscriptionTypeEnum.DevicesContentReport:
            return "reportSubscription.devicesContentReport";
        case ReportSubscriptionTypeEnum.LastDayTransactionsReport:
            return "reportSubscription.lastDayTransactionsReport";
        case ReportSubscriptionTypeEnum.DevicesContentCsvReport:
            return "reportSubscription.devicesContentCsvReport";
        case ReportSubscriptionTypeEnum.PlatformMaintenanceReport:
            return "reportSubscription.platformMaintenanceReport";
        default:
            return "common.unknown";
    }
}

export function getSubscriptionRequiredPrivileges(t: string): ClientPrivileges {
    switch (parseInt(t) as ReportSubscriptionTypeEnum) {
        case ReportSubscriptionTypeEnum.DevicesContentReport:
            return ClientPrivileges.CashFlowContentMonitoring;
        case ReportSubscriptionTypeEnum.LastDayTransactionsReport:
            return ClientPrivileges.CashFlowTransactionsReporting;
        case ReportSubscriptionTypeEnum.DevicesContentCsvReport:
            return ClientPrivileges.CashFlowContentMonitoring;
        case ReportSubscriptionTypeEnum.PlatformMaintenanceReport:
            return ClientPrivileges.PlatformMaintenance;
        default:
            return ClientPrivileges.None;
    }
}
